import { defineMessages } from 'react-intl';

export const Modal = defineMessages({
  close: {
    id: 'app.common.close',
    defaultMessage: 'Zavřít',
  },
  cancel: {
    id: 'app.common.cancel',
    defaultMessage: 'Zrušit',
  },
  ok: {
    id: 'app.common.ok',
    defaultMessage: 'OK',
  },
  logoutAction: {
    id: 'app.common.logoutAction',
    defaultMessage: 'Odhlásit se',
  },
  logoutConfirmation: {
    id: 'app.common.logoutConfirmation',
    defaultMessage: 'Opravdu se chcete odhlásit?',
  },
  logoutFromApp: {
    id: 'app.common.logoutFromApp',
    defaultMessage: 'Odhlášení z aplikace',
  },
  english: {
    id: 'app.common.english',
    defaultMessage: 'English',
  },
  czech: {
    id: 'app.common.czech',
    defaultMessage: 'Čeština',
  },
  slovak: {
    id: 'app.common.slovak',
    defaultMessage: 'Slovenčina',
  },
  polish: {
    id: 'app.common.polish',
    defaultMessage: 'Polski',
  },
  settings: {
    id: 'app.common.settings',
    defaultMessage: 'Nastavení',
  },
  selectLanguage: {
    id: 'app.SettingsModal.selectLanguage',
    defaultMessage: 'Vyber jazyk',
  },
  sending: {
    id: 'app.common.sending',
    defaultMessage: 'Odesílám...',
  },
  send: {
    id: 'app.common.send',
    defaultMessage: 'Odeslat',
  },
  save: {
    id: 'app.common.save',
    defaultMessage: 'Uložit',
  },
  sendOptions: {
    id: 'app.SyncModal.sendOptions',
    defaultMessage: 'Chceš tento záznam rovnou odeslat nebo jej máme uložit do paměti telefonu k pozdějšímu odeslání?',
  },
  launch: {
    id: 'app.SyncModal.launch',
    defaultMessage: 'Spustit',
  },
  getReady: {
    id: 'app.SyncModal.getReady',
    defaultMessage: 'Pohodlně se usaď, za okamžik začínáme!',
  },
  rememberValues: {
    id: 'app.SyncModal.rememberValues',
    defaultMessage: 'Zapamatovat hodnoty',
  },
  doNotRememberValues: {
    id: 'app.SyncModal.doNotRememberValues',
    defaultMessage: 'Nezapamatovat hodnoty',
  },
  confirm: {
    id: 'app.SyncModal.confirm',
    defaultMessage:
      'Synchronizovat offline záznamy? Ve frontě právě čeká {queuedCount} záznamů. Tato operace může být časově náročná.',
  },
  inProgress: {
    id: 'app.SyncModal.inProgress',
    defaultMessage: 'Dobrá práce zatím to jde dobře...',
  },
  finished: {
    id: 'app.SyncModal.finished',
    defaultMessage: 'Tak a je to! °˖✧◝(⁰▿⁰)◜✧˖°',
  },
  recordSynchronization: {
    id: 'app.SyncModal.recordSynchronization',
    defaultMessage: 'Synchronizace {type} záznamů',
  },
  installationMeters: {
    id: 'app.SyncModal.installationMeters',
    defaultMessage: 'instalačních',
  },
  passportedMeters: {
    id: 'app.SyncModal.passportedMeters',
    defaultMessage: 'pasportovaných',
  },
});
